import { createBrowserRouter } from "react-router";
import { RootRoutes } from "src/router/routes";
import { panelAwareDataStrategy } from "src/router/dataStrategy";
import config from "react-global-configuration";

let opts: { dataStrategy: typeof panelAwareDataStrategy; basename?: string } = {
  dataStrategy: panelAwareDataStrategy,
};

if (config.get("BASE_PATH")) {
  opts = { ...opts, basename: config.get("BASE_PATH") };
}

export const appRouter = createBrowserRouter(RootRoutes, opts);
